

















import { Component, Prop, Vue } from 'vue-property-decorator'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'

@Component
export default class ThankYou extends Vue {
  @Prop() public waiterName!: string
  @Prop() public roomId?: string

  public returning: boolean = false
  public restaurantId: string = ''
  public accessCode: string = ''
  public restaurant: RestaurantPublic | null = null

  public async created() {
    this.returning = !!this.$route.query.r
    this.restaurantId = this.$route.params.restaurantId
    this.accessCode = this.$route.params.accessCode

    if (this.restaurantId) {
      this.restaurant = await restaurants.getPublicRestaurant(this.restaurantId)
    }
  }

  public get tipUrl() {
    const restaurantName = this.restaurant?.name
    const returnToRoomUrl = this.$router.resolve({
      name: 'seating',
      params: {
        lang: this.$route.params.lang,
        restaurantId: this.restaurantId,
        accessCode: this.accessCode,
      },
    }).href

    const returnToPageUrl = this.$router.resolve({
      name: 'thankyou',
      params: {
        lang: this.$route.params.lang,
        restaurantId: this.restaurantId,
        accessCode: this.accessCode,
      },
    }).href

    // r means the user is returning, so we won't show the tip div anymore
    const returnUrl = this.roomId
      ? `${location.origin}${returnToRoomUrl}?rid=${this.roomId}&r=1`
      : `${location.origin}${returnToPageUrl}?r=1`

    return `https://gastrohome.com/fooi-geven/?restaurant=${restaurantName || ''}&ober=${this
      .waiterName || ''}&returnurl=${encodeURIComponent(returnUrl || '')}`
  }
}
